import Tezaurus from '../../../../../model/Tezaurus';
import { ClientStatus } from '../../../../../model/ClientStatus';
import { useClientFetch } from '../../../../../context/ClientStatusContext';
import { fetchTezaurusList } from '../../../../../client/tezaurus/tezaurusListClient';

interface ReturnType {
  tezaurusList: Array<Tezaurus>;
  tezaurusStatus: ClientStatus;
  reloadTezaurusList():void;
}

export default (): ReturnType => {
  const {
    data: tezaurusList,
    status: tezaurusStatus,
    refetch: reloadTezaurusList,
  } = useClientFetch(fetchTezaurusList, [], []);
  return <ReturnType>{ tezaurusList, tezaurusStatus, reloadTezaurusList };
};
